import { CoverageHoursEntry, CoverageHoursPairing } from './useCoverageHours';

export type CoverageHoursBlockRow = CoverageHoursEntry & { isChild: true };

export type CoverageHoursPairingRow = CoverageHoursPairing & {
  id: string;
  isChild: false;
  children: CoverageHoursBlockRow[];
  teamNames: string[];
};

export type CoverageHoursTableRow =
  | CoverageHoursPairingRow
  | CoverageHoursBlockRow;

// Grouped on the category and issue names the create panel writes: a pairing's
// routing id is server-assigned, so it cannot group an optimistic row with the
// rows it will join.
const pairingId = ({ category, issue }: CoverageHoursEntry) =>
  JSON.stringify([category, issue]);

export function buildCoverageHoursTableRows(
  entries: CoverageHoursEntry[]
): CoverageHoursPairingRow[] {
  const pairings = new Map<string, CoverageHoursPairingRow>();

  entries.forEach(entry => {
    const id = pairingId(entry);
    const block: CoverageHoursBlockRow = { ...entry, isChild: true };
    const pairing = pairings.get(id);

    if (pairing) {
      pairing.children.push(block);

      if (entry.teamName && !pairing.teamNames.includes(entry.teamName)) {
        pairing.teamNames.push(entry.teamName);
      }

      return;
    }

    pairings.set(id, {
      id,
      routingId: entry.routingId,
      category: entry.category,
      issue: entry.issue,
      isChild: false,
      children: [block],
      teamNames: entry.teamName ? [entry.teamName] : [],
    });
  });

  return Array.from(pairings.values());
}

export function coverageHoursSubRows(
  row: CoverageHoursTableRow
): CoverageHoursTableRow[] | undefined {
  return row.isChild ? undefined : row.children;
}

export function coverageHoursBlockIds(row: CoverageHoursTableRow): string[] {
  return row.isChild ? [row.id] : row.children.map(({ id }) => id);
}
